import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import FlowStateManagement from './FlowStateManagement';

export default {
    icon: ArrowForwardIcon,
    recordRepresentation: 'reference',
    list: FlowStateManagement
};
